// extracted by css-extract-rspack-plugin
export default {"ConfirmMergeContainer":"ConfirmMerge-module__ConfirmMergeContainer__WPGfB","ConfirmMergeText":"ConfirmMerge-module__ConfirmMergeText__gt6dF"};